import { UnUploadedImage } from "components/PhotoUpload/types";

export const uniqueByHash = (photo: UnUploadedImage, index: number, photos: UnUploadedImage[]) => {
  return photos.findIndex((p) => p.hash === photo.hash) === index;
};
